module.exports = __webpack_public_path__ + "static/forecast/weather/dayrainshowers-e756230f54f7cdea37eefd123c6cdc88.svg";